import { useCallback, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { routes } from 'routes/routes';

export const useGivingNavigation = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const paymentRedirectUrl = useMemo(() => pathname.slice(1), [pathname]);

  const navigateToGivingBrowse = useCallback(async () => {
    await navigate(routes.giving.browse);
  }, [navigate]);

  const navigateToGiveNow = useCallback(async () => {
    await navigate(routes.giving.now);
  }, [navigate]);

  return useMemo(
    () => ({ navigateToGiveNow, navigateToGivingBrowse, paymentRedirectUrl }),
    [navigateToGivingBrowse, navigateToGiveNow, paymentRedirectUrl],
  );
};
